const get_CSRF_token = () => {
    const name = 'csrf_access_token'
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

export default get_CSRF_token;